import script from "./editPackage.vue?vue&type=script&setup=true&lang=js"
export * from "./editPackage.vue?vue&type=script&setup=true&lang=js"

import "./editPackage.vue?vue&type=style&index=0&id=22fc8ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22fc8ce2"]])

export default __exports__